/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-15 08:43:54
 * @Description: 不可进行二次销售
 */
export default {
  // 通用错误 (1000-1999)
  1000: '未知错误',
  1001: '请求参数错误',
  1002: '未授权访问',
  1003: '访问被拒绝',
  1004: '资源不存在',
  1005: '请求方法不允许',
  1006: '请求超时',
  1007: '服务器内部错误',
  1008: '服务不可用',
  1009: '数据库操作失败',
  1010: '数据格式错误',

  // 用户认证相关 (2000-2999)
  2000: '用户不存在',
  2001: '密码错误',
  2002: '账号已被禁用',
  2003: '账号已过期',
  2004: '验证码错误',
  2005: '验证码已过期',
  2006: 'token无效',
  2007: 'token已过期',
  2008: 'refresh token无效',
  2009: '账号已存在',
  2010: '邮箱已被注册',
  2011: '手机号已被注册',
  2012: '用户名已被占用',
  2013: '密码强度不足',
  2014: '两次密码不一致',
  2015: '原密码错误',
  2016: '登录失败次数过多',

  // 作品相关 (3000-3999)
  3000: '作品不存在',
  3001: '作品已下架',
  3002: '作品审核中',
  3003: '作品审核失败',
  3004: '作品已达上限',
  3005: '作品标题已存在',
  3006: '作品分类不存在',
  3007: '作品标签不存在',
  3008: '章节不存在',
  3009: '章节已发布',
  3010: '章节已达上限',

  // 收益相关 (4000-4999)
  4000: '余额不足',
  4001: '提现金额不能小于100元',
  4002: '提现金额不能大于余额',
  4003: '提现账户不存在',
  4004: '今日提现次数已达上限',
  4005: '提现正在处理中',
  4006: '提现记录不存在',
  4007: '结算失败',
  4008: '收益记录不存在',

  // 消息相关 (5000-5999)
  5000: '消息不存在',
  5001: '消息已读',
  5002: '消息发送失败',
  5003: '消息类型错误',
  5004: '消息接收者不存在',

  // 设置相关 (6000-6999)
  6000: '个人资料更新失败',
  6001: '头像上传失败',
  6002: '手机绑定失败',
  6003: '邮箱绑定失败',
  6004: '通知设置更新失败',
  6005: '隐私设置更新失败',

  // 文件上传相关 (7000-7999)
  7000: '文件上传失败',
  7001: '文件类型不支持',
  7002: '文件大小超过限制',
  7003: '文件数量超过限制',
  7004: '文件不存在',
  7005: '文件下载失败',

  // 权限相关 (8000-8999)
  8000: '没有操作权限',
  8001: '角色不存在',
  8002: '权限标识不存在',
  8003: '角色已被使用',
  8004: '权限配置错误',

  // 业务限制 (9000-9999)
  9000: '操作过于频繁',
  9001: '今日操作次数已达上限',
  9002: '功能暂未开放',
  9003: '系统维护中',
  9004: '版本过低，请升级',
  9005: '操作已取消'
}